import { Fragment } from 'react'
import { ProductExtendedTyShort } from '../../../types'
import { faChevronsLeft } from '@fortawesome/pro-light-svg-icons'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import TwinIcon from '../../../../../baseComponents/TwinIcon'
import TwinToolTip from '../../../../../baseComponents/TwinToolTip'
import { getBasePath } from '../../../../../utils/globals/link'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'

interface WrapperProductTabsProps {
    children: React.ReactNode
    basicData: ProductExtendedTyShort
}

const WrapperProductTabs: React.FC<WrapperProductTabsProps> = ({ children, basicData }) => {
    if (!basicData?.ProductId) {
        return <Fragment>{children}</Fragment>
    }
    return <div className='flex flex-auto flex-col wrapper_product_tabs'>
        <HeaderProductParent basicData={basicData} />
        {children}
    </div>
}

interface HeaderProductParentProps {
    basicData: ProductExtendedTyShort
}

const HeaderProductParent: React.FC<HeaderProductParentProps> = ({ basicData }) => {
    const { t } = useTwinTranslation()
    const location = useLocation()
    if (!basicData?.ProductId) {
        return null
    }
    const idToolTip = 'ProductParent_' + basicData.ProductId
    return (
        <div className='mb-5'>
            <TwinToolTip id={idToolTip} content={t('goToParent', 'Ir al padre')} place='top' />
            <Link data-tooltip-id={idToolTip} className='cursor-pointer hover:text-green-43 w-max mb-5' to={getBasePath(location.pathname, String(basicData.id), true) + '/' + basicData.ProductId + '/main'}>
                <TwinIcon icon={faChevronsLeft} />
                <span className='ml-20'>{basicData.ProductParentReference} - {basicData.ProductParentName}</span>
            </Link>
        </div>
    )
}

export default WrapperProductTabs